module.exports = Object.freeze({
    NONE: 0,                // none
    RESERVED: 1,            // reserved
    COORDINATOR: 2,         // (about coordinator)
    GROUP: 3,               // (about group)
    GIVER: 4,               // (about giver)
    RECEIVER: 5,            // (about receiver)
    GIFT: 6,                // (about gift)
    NEED: 7,                // (about need)
    TASK: 8,                // (about task)
  });
